import { ILocationResponse } from '@kcftech/prometheus-client';
import { DocumentTitle } from 'components/DocumentTitle';
import { DebouncedSearchInput } from 'components/data/DebouncedSearchInput';
import { TablePageLayout } from 'components/page/styled';
import { usePagedTemplatesDataSource } from 'custom_hooks/data_hooks/data_source/templatesDataSource';
import { SearchCreateButtonContainer } from 'pages/Settings/shared/styled';
import TemplatesTable from 'pages/Settings/Templates/TemplatesTable';
import { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

export type TemplatesPageProps = Readonly<{
    location: ILocationResponse;
}>;

export function TemplatesPage({ location }: TemplatesPageProps) {
    const routerLocation = useLocation();
    const dataSource = usePagedTemplatesDataSource({
        name: 'templates-table',
        defaultFilter: {
            locationId: location.Id,
            nameSearch: '',
        },
    });

    const { filter, setFilter, reloadPage } = dataSource;

    useEffect(() => {
        setFilter((currentFilter) => ({
            ...currentFilter,
            nameSearch: filter.nameSearch,
        }));
    }, [filter.nameSearch, setFilter]);

    useEffect(() => {
        reloadPage();
    }, [routerLocation.pathname, reloadPage]);

    return (
        <Switch>
            {/* @ts-expect-error: type issue with older version of react-router-dom */}
            <Route default>
                <TablePageLayout>
                    <DocumentTitle title={`${location.Name} Templates Settings`} />
                    <SearchCreateButtonContainer>
                        <DebouncedSearchInput
                            placeholder="Search"
                            value={filter.nameSearch}
                            onChange={(newNameSearch) =>
                                setFilter((currentFilter) => ({
                                    ...currentFilter,
                                    nameSearch: newNameSearch,
                                }))
                            }
                        />
                    </SearchCreateButtonContainer>
                    <TemplatesTable dataSource={dataSource} locationId={location.Id} />
                </TablePageLayout>
            </Route>
        </Switch>
    );
}
